import { setStylesProperties } from 'app/shared/util/methode-util';
import { cmsApi } from '../api';
import { ACTION_TYPES } from './store/actions';

export const getDocCMS = (docType: string, generic?: boolean) => async (dispatch, getState) => {
  const { documents } = await getState().cms;
  if (documents[docType] === undefined) {
    await dispatch({
      type: ACTION_TYPES.GET_DOCUMENTS,
      payload: async () => ({ docs: await cmsApi.getDocCMS(docType, generic), type: docType }),
    });

    const cms = await getState().cms;
    if (docType === 'app_global_type') {
      setStylesProperties(cms.documents[docType]?.data);
    }
  }
};
export const getDocCMSContractDocument = (defaultValue:boolean,documentName:string)=> async (dispatch, getState) =>{

  const { documents } = await getState().cms;
  if (documents[documentName] === undefined) {
    await dispatch({
      type: ACTION_TYPES.GET_DOCUMENTS,
      payload: async () => ({ docs: await cmsApi.getDocCMSContractDocument(defaultValue,documentName), type: documentName }),
    }); 
  }

}
